define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller"
], function (declare, _, Controller) {

	return declare(Controller, {
		process: function () {
			// summary: validate current view to see if action can continue processing
			if (this.widget.getNextPage()) {
				this.setProgress();
				this.disableActionView(true);

				// defer to allow button to process
				_.defer(function (self) {
					// validate and proceed to next page
					self.when(self.validate(), function () {
						self.when(self.widget.nextPage(), function () {
							self.postProcess(true);
						});
					});
				}, this);
			} else {
				this.postProcess();
			}
		},

		_validateForm: function (/*csi.view.Widget*/wizard) {
			// summary: validate current page before proceeding to next page
			return this.inherited(arguments, [wizard.getSelectedPage().getView(wizard)]);
		}
	});
});